/* Keepsake Magnets Co. - conversion kit (added 2026-10-12, ?v=20261012a)
 * 1. Free shipping progress bar (cart drawer + /cart page), $35 threshold.
 * 2. Sticky add-to-cart on mobile product pages. On uploader product pages
 *    the theme's native sticky bar is hidden (see CSS) and ours scrolls the
 *    shopper back to the photo uploader instead of adding blindly.
 * 5. Email capture popup (20s or exit intent, 30 day suppression).
 * No prices or product data are changed by this file.
 */
(function () {
  'use strict';

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  var FREE_SHIP_THRESHOLD = 3500; // $35.00 in cents

  /* ================= 1. Free shipping progress bar ================= */
  (function shipBar() {
    var lastTotal = null;
    var lastCount = null;

    function mounts() {
      var out = [];
      var drawerContent = $('.cart-drawer__content');
      if (drawerContent) out.push({ el: drawerContent, kind: 'drawer' });
      if (window.location.pathname === '/cart') {
        var comp = $('cart-items-component');
        if (comp) out.push({ el: comp.querySelector('.section') || comp, kind: 'page' });
      }
      return out;
    }

    function ensureBar(mount) {
      var bar = mount.el.querySelector(':scope > .ks-shipbar');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ks-shipbar';
        bar.setAttribute('role', 'status');
        bar.innerHTML =
          '<p class="ks-shipbar__text"></p>' +
          '<div class="ks-shipbar__track"><div class="ks-shipbar__fill"></div></div>';
        mount.el.insertBefore(bar, mount.el.firstChild);
      }
      return bar;
    }

    function render(cart) {
      var list = mounts();
      if (!list.length) return;
      for (var i = 0; i < list.length; i++) {
        var bar = ensureBar(list[i]);
        if (!cart.item_count) { bar.style.display = 'none'; continue; }
        bar.style.display = '';
        var total = cart.total_price || 0;
        var textEl = bar.querySelector('.ks-shipbar__text');
        var fillEl = bar.querySelector('.ks-shipbar__fill');
        if (total >= FREE_SHIP_THRESHOLD) {
          bar.classList.add('ks-shipbar--unlocked');
          textEl.innerHTML = 'You unlocked <strong>FREE shipping</strong>';
          fillEl.style.width = '100%';
        } else {
          bar.classList.remove('ks-shipbar--unlocked');
          textEl.innerHTML = 'You are <strong>' + money(FREE_SHIP_THRESHOLD - total) +
            '</strong> away from <strong>FREE shipping</strong>';
          fillEl.style.width = Math.max(2, Math.round((total / FREE_SHIP_THRESHOLD) * 100)) + '%';
        }
      }
    }

    function refresh() {
      if (!mounts().length) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          if (cart.total_price === lastTotal && cart.item_count === lastCount) {
            render(cart); // still re-render: the drawer may have re-mounted
            return;
          }
          lastTotal = cart.total_price;
          lastCount = cart.item_count;
          render(cart);
        })
        .catch(function () {});
    }

    var debounce = null;
    function scheduleRefresh(ms) {
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(refresh, ms || 700);
    }

    function barVisible() {
      var bar = $('.ks-shipbar');
      if (!bar) return false;
      if (typeof bar.checkVisibility === 'function') return bar.checkVisibility();
      return !!(bar.offsetWidth || bar.offsetHeight);
    }

    function start() {
      refresh();
      // Quantity changes re-render the cart via AJAX; catch them three ways:
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.cart-drawer, cart-items-component, .cart')) {
          scheduleRefresh(800);
        }
      }, true);
      document.addEventListener('change', function () { scheduleRefresh(800); }, true);
      var drawer = $('cart-drawer-component');
      if (drawer && window.MutationObserver) {
        new MutationObserver(function () { scheduleRefresh(600); })
          .observe(drawer, { childList: true, subtree: true, attributes: true });
      }
      // While the drawer is open (or on /cart), keep the bar truthful.
      setInterval(function () { if (barVisible()) refresh(); }, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else { start(); }
  })();

  /* ================= 2. Sticky add-to-cart (mobile) ================= */
  (function stickyBar() {
    if (window.location.pathname.indexOf('/products/') === -1) return;

    var uploaderRoot = null;
    function findUploader() {
      uploaderRoot = $('[data-keepsake-upload]');
      if (uploaderRoot) document.documentElement.classList.add('ks-uploader-page');
      return uploaderRoot;
    }

    function build() {
      findUploader();
      var nativeSticky = $('sticky-add-to-cart');
      // Non-uploader products: Horizon's native sticky bar already does
      // this job; do not stack a second bar on top of it.
      if (!uploaderRoot && nativeSticky) return;
      // Uploader products with no native bar would also be fine, but the
      // CSS hides the native one whenever an uploader is present, and the
      // custom bar below is the uploader-safe replacement.

      var bar = document.createElement('div');
      bar.className = 'ks-sticky';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Quick actions');
      var title = '';
      var h1 = $('h1');
      if (h1) title = h1.textContent.trim();
      if (!title) title = document.title.split('|')[0].trim();
      if (title.length > 30) title = title.slice(0, 29).trim() + '…';
      bar.innerHTML =
        '<span class="ks-sticky__title"></span>' +
        '<button type="button" class="ks-sticky__btn"></button>';
      bar.querySelector('.ks-sticky__title').textContent = title;
      var btn = bar.querySelector('.ks-sticky__btn');
      btn.textContent = uploaderRoot ? 'Add photos to start' : 'Add to cart';
      document.body.appendChild(bar);

      btn.addEventListener('click', function () {
        if (uploaderRoot) {
          uploaderRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var form = $('form[action*="/cart/add"], form[action*="/cart"]');
        var realBtn = form ? (form.querySelector('button[name="add"], [type="submit"]')) : null;
        if (realBtn) { realBtn.click(); return; }
        if (form) {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }
      });

      var mq = window.matchMedia('(max-width: 749px)');
      function buyButton() {
        return $('form[action*="/cart/add"] button[name="add"], .product-form__submit, form button[name="add"]');
      }
      var buyVisible = true;
      function update() {
        var show = mq.matches && !buyVisible;
        bar.classList.toggle('ks-sticky--visible', !!show);
      }
      function observe() {
        var target = buyButton();
        if (!target || !window.IntersectionObserver) { buyVisible = false; update(); return; }
        new IntersectionObserver(function (entries) {
          buyVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.05 }).observe(target);
      }
      if (mq.addEventListener) mq.addEventListener('change', update);
      observe();
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else { build(); }
  })();

  /* ================= 5. Email capture popup ================= */
  (function emailPopup() {
    var path = window.location.pathname;
    if (path === '/cart' || path.indexOf('/checkout') === 0 || path.indexOf('/checkouts') === 0) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var KEY = 'ks_popup_v1';
    var SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000;
    try {
      var saved = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (saved && saved.t && (Date.now() - saved.t) < SUPPRESS_MS) return;
    } catch (e) {}

    var shown = false;
    var overlay = null;

    function remember(state) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify({ s: state, t: Date.now() }));
      } catch (e) {}
    }

    function close(state) {
      if (state) remember(state);
      if (!overlay) return;
      overlay.classList.remove('ks-popup-overlay--open');
      document.body.classList.remove('ks-popup-open');
      var el = overlay;
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
      overlay = null;
    }

    function showSuccess(signupFailed) {
      var card = overlay.querySelector('.ks-popup');
      card.innerHTML =
        '<button type="button" class="ks-popup__close" aria-label="Close">&times;</button>' +
        '<p class="ks-popup__headline">You are in!</p>' +
        '<p class="ks-popup__body">Your code:</p>' +
        '<span class="ks-popup__code">WELCOME10</span>' +
        '<p class="ks-popup__body">Use it at checkout for 10% off your first order.</p>' +
        (signupFailed
          ? '<p class="ks-popup__fineprint">If the signup did not go through, the code still works.</p>'
          : '');
      card.querySelector('.ks-popup__close').addEventListener('click', function () { close('s'); });
    }

    function build() {
      overlay = document.createElement('div');
      overlay.className = 'ks-popup-overlay';
      overlay.innerHTML =
        '<div class="ks-popup" role="dialog" aria-modal="true" aria-label="Get 10% off your first magnets">' +
          '<button type="button" class="ks-popup__close" aria-label="Close">&times;</button>' +
          '<p class="ks-popup__headline">Get 10% off your first magnets</p>' +
          '<p class="ks-popup__body">Join the list for gift ideas, early Christmas cutoffs, and 10% off your first order.</p>' +
          '<form class="ks-popup__form" novalidate>' +
            '<input class="ks-popup__input" type="email" name="email" placeholder="Your email address" autocomplete="email" required>' +
            '<button class="ks-popup__submit" type="submit">Claim 10% off</button>' +
          '</form>' +
        '</div>';
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close('d');
      });
      overlay.querySelector('.ks-popup__close').addEventListener('click', function () { close('d'); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay) close('d');
      });

      overlay.querySelector('.ks-popup__form').addEventListener('submit', function (e) {
        e.preventDefault();
        var input = overlay.querySelector('.ks-popup__input');
        var email = (input.value || '').trim();
        if (!email || email.indexOf('@') === -1) { input.focus(); return; }
        var submitBtn = overlay.querySelector('.ks-popup__submit');
        submitBtn.disabled = true;
        submitBtn.textContent = 'One sec…';
        var body = new URLSearchParams();
        body.set('form_type', 'customer');
        body.set('utf8', '✓');
        body.set('contact[tags]', 'newsletter');
        body.set('contact[email]', email);
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString(),
          credentials: 'same-origin'
        }).then(function () {
          remember('s');
          showSuccess(false);
        }).catch(function () {
          remember('s');
          showSuccess(true);
        });
      });
    }

    function show() {
      if (shown || overlay) return;
      shown = true;
      build();
      document.body.classList.add('ks-popup-open');
      requestAnimationFrame(function () {
        if (overlay) overlay.classList.add('ks-popup-overlay--open');
      });
    }

    // Trigger 1: 20 seconds on site.
    setTimeout(show, 20000);
    // Trigger 2: exit intent (desktop, pointer leaves toward the top).
    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 8) show();
      });
    }
  })();
})();
